import { Box, Stack, Typography } from '@mui/material';
import { HeaderPortal } from 'components/header-portal';
import { TabsPage } from 'components/tabs-page';
import { APP_ROUTES } from 'configs';
import { useTranslate } from 'hooks';
import { memo, useMemo } from 'react';
import style from './index.module.scss';

export const LabelsLayout = memo(() => {
  const { tp } = useTranslate();
  const tabs = useMemo(() => {
    return [
      {
        value: APP_ROUTES.LABELS.path,
        to: APP_ROUTES.LABELS().config,
        label: tp('website'),
      },
      {
        value: APP_ROUTES.CMS.path,
        to: APP_ROUTES.CMS().config,
        label: tp('cms'),
      },
      {
        value: APP_ROUTES.LANGUAGES.path,
        to: APP_ROUTES.LANGUAGES().config,
        label: tp('languages'),
      },
    ];
  }, [tp]);
  return (
    <>
      <HeaderPortal>
        <Stack height={'100%'} justifyContent={'center'}>
          <Typography variant={'h2'} component={'h1'} noWrap>
            {tp('labels')}
          </Typography>
        </Stack>
      </HeaderPortal>
      <Box className={style.root}>
        <Box className={style.inner}>
          <TabsPage tabs={tabs} />
        </Box>
      </Box>
    </>
  );
});
